// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".releases-item img {\n  width: 100%;\n}\n\n.releases-item ul {\n  padding-left: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
